__turbopack_context__.v({
  "group": "variant-picker-module-scss-module__rK_eJW__group",
  "label": "variant-picker-module-scss-module__rK_eJW__label",
  "live": "variant-picker-module-scss-module__rK_eJW__live",
  "look-size": "variant-picker-module-scss-module__rK_eJW__look-size",
  "root": "variant-picker-module-scss-module__rK_eJW__root",
  "sizes": "variant-picker-module-scss-module__rK_eJW__sizes",
  "swatches": "variant-picker-module-scss-module__rK_eJW__swatches",
  "tip": "variant-picker-module-scss-module__rK_eJW__tip",
  "value": "variant-picker-module-scss-module__rK_eJW__value",
});
